
import FormBase from './components/FormBase.vue'
import CheckoutCourseParticipants from './components/CheckoutCourseParticipants/CheckoutCourseParticipants.vue'
import Store from 'store'
import verifyLabel from '../../../methods/verifyLabel'

import notempty from './methods/validateNotEmpty'
import novalidation from './methods/novalidation'
import validateEmail from './methods/validateEmail'
import validateMaxLength from './methods/validateMaxLength'
import generateInput from './methods/generateInputField'
import includeInValidation from './methods/includeInValidation'
import validateRepeatedEmail from './methods/validateRepeatedEmail'

export default {
    name: 'checkout-billing',
    props: {
        action: String
    },
    data(){
        return {
            windowWidth: 0,
            alternateParticipant: false,
            readyToSubmit: null,
            useAlternateDeliveryAddress: false,
            form : {
                firstname: generateInput('text','Invoice.FirstName', 'inputLabelFirstname', true , true, notempty),
                lastname: generateInput('text','Invoice.LastName', 'inputLabelLastname', true, true, notempty),
                telephone: generateInput('text','Invoice.Phone', 'inputLabelPhone', true, true, notempty),
                email: generateInput('text','Invoice.Mail', 'inputLabelEmail', true, true, validateEmail),
                email_repeat: generateInput('text','Invoice.MailRepeat', 'inputLabelConfirmEmail', true, true, validateRepeatedEmail.bind(this,'email')),
                country: generateInput('select','Invoice.CountryCode', 'inputLabelCountry', true, true, notempty,this.getCountryNames()),
                city: generateInput('text','Invoice.City', 'inputLabelCity', true, true, notempty),
                zipcode: generateInput('number','Invoice.Zip', 'inputLabelZipcode', true, true, notempty),
                street: generateInput('text','Invoice.StreetName', 'inputLabelStreet', true, true, notempty),
                floor: generateInput('text','Invoice.Floor', 'inputLabelFloor', false, true, notempty),
                company: generateInput('text','Invoice.CompanyName', 'inputLabelCompany', true, true, notempty),
                cvr: generateInput('text','Invoice.CvrNumber', 'inputLabelCvr', true, true, notempty, null, null, 20),
                reference: generateInput('text', 'Invoice.RefNumber', 'inputLabelReference', false, true, novalidation, null, null, 20),
                ean: generateInput('text','Invoice.EanNumber', 'inputLabelEan', false, true, novalidation, null, null, 13),
                comment: generateInput('textarea','Invoice.Comment', 'inputLabelComment', false, true, validateMaxLength.bind(this, 750), null, null, 750),

                delivery_firstname: generateInput('text','OtherInvoice.FirstName', 'inputLabelFirstname', true, 'useAlternateDeliveryAddress', notempty),
                delivery_lastname: generateInput('text','OtherInvoice.LastName', 'inputLabelLastname', true, 'useAlternateDeliveryAddress', notempty),
                delivery_phone: generateInput('text','OtherInvoice.Phone', 'inputLabelPhone', true, 'useAlternateDeliveryAddress', notempty),
                delivery_email: generateInput('text','OtherInvoice.Mail', 'inputLabelEmail', true, 'useAlternateDeliveryAddress', validateEmail),
                delivery_email_repeat: generateInput('text','OtherInvoice.MailRepeat', 'inputLabelConfirmEmail', true, 'useAlternateDeliveryAddress', validateRepeatedEmail.bind(this,'delivery_email')),
                delivery_city: generateInput('text','OtherInvoice.City', 'inputLabelCity', true, 'useAlternateDeliveryAddress', notempty),
                delivery_zipcode: generateInput('number','OtherInvoice.Zip', 'inputLabelZipcode', true, 'useAlternateDeliveryAddress', notempty),
                delivery_street: generateInput('text','OtherInvoice.StreetName', 'inputLabelStreet', true, 'useAlternateDeliveryAddress', notempty),
                delivery_floor: generateInput('text','OtherInvoice.Floor', 'inputLabelFloor', false, 'useAlternateDeliveryAddress', notempty),
                delivery_country: generateInput('select','OtherInvoice.CountryCode', 'inputLabelCountry', true, 'useAlternateDeliveryAddress', notempty,this.getCountryNames()),
            },
            participantForm: {},
            participantFieldlist: [
                'Name',
                'Email',
                'Position',
                'Phone'
            ]
        }
    },
    computed:{
        startAlternateParticipantFieldsDisabled(){
            return this.showAlternateParticipantInputCheckbox ? !this.alternateParticipant : false
        },
        showAlternateParticipantInputCheckbox(){
            const threshold = 1
            const numberOfCourses = this.$store.state.cart.courseInfoForCheckout.length
            let highestParticipantCount = 0
            if(numberOfCourses){
                const courses = this.$store.state.cart.courseInfoForCheckout
                highestParticipantCount = courses.reduce((total,current) =>{
                    return total < current.participantCount ? current.participantCount : total
                },highestParticipantCount)
            }

            return !!(numberOfCourses === threshold && highestParticipantCount === threshold)
        },
        showCourseParticipantInput(){
            return !!(this.$store.state.cart.courseInfoForCheckout.length)
        },
        courseParticipantList(){
            return this.$store.state.cart.courseInfoForCheckout
        },
        formNameGroup1(){
            return [
                this.form.company,
                this.form.cvr,
            ]
        },
        formNameGroup2(){
            return [
                this.form.reference,
                this.form.ean,  
            ]
        },
        formAddressGroup1(){
            return [     
                this.form.firstname,
                this.form.lastname,
                this.form.telephone,
                this.form.email,
                this.form.email_repeat
            ]
        },
        formAddressGroup2(){
            return [
                this.form.street,
                this.form.floor,
                this.form.zipcode, 
                this.form.city,
                this.form.country,
                
            ]
        },
        formRefGroup1(){
            return [
                this.form.comment
                
            ]
        },
        formRefGroup2(){
            return [
                
            ]
        },
        invoiceCol1(){
            return [
                this.formNameGroup1,
                this.formAddressGroup1,
                this.formRefGroup1
            ]
        },
        invoiceCol2(){
            return [
                this.formNameGroup2,
                this.formAddressGroup2,
                this.formRefGroup2
            ]
        },
        invoiceForm(){
            return [
                this.invoiceCol1,
                this.invoiceCol2
            ]
        },

        deliveryFormLeftGroup1() {
            return [
                this.form.delivery_firstname,
                this.form.delivery_lastname,
                this.form.delivery_phone,
                this.form.delivery_email,
                this.form.delivery_email_repeat,                
            ]
        },

        deliveryFormRightGroup1() {
            return [
                this.form.delivery_street,
                this.form.delivery_floor,
                this.form.delivery_zipcode,
                this.form.delivery_city,                
                this.form.delivery_country
            ]
        },

        deliveryCol1() {
            return [
                this.deliveryFormLeftGroup1,
            ]   
        },

        deliveryCol2() {
            return [
                this.deliveryFormRightGroup1,
            ]   
        },    

        deliveryForm() {
            return [
                this.deliveryCol1,
                this.deliveryCol2
            ]
        },           

        mobileCheckoutForm() {
            return [ // the tripple nesting is reqiured to make best use of template in mobile view
                [
                    [
                        this.form.company,
                        this.form.cvr,
                        this.form.reference,
                        this.form.ean,
                    ],
                    [
                        this.form.firstname,
                        this.form.lastname,
                        this.form.telephone,
                        this.form.email,
                        this.form.email_repeat,
                        this.form.comment
                    ],
                    [
                        this.form.street,
                        this.form.floor,
                        this.form.zipcode,
                        this.form.city,
                        this.form.country
                    ]
                ]
            ]
        },

        participantSignupForm(){
            const updateIfTheseFieldsChange = this.form.firstname.value+this.form.lastname.value+this.form.email.value+this.form.telephone.value+this.alternateParticipant

            if(this.showCourseParticipantInput){
                const fieldlist = this.participantFieldlist

                // each course
                return this.courseParticipantList.map((course,courseIndex) => {

                    const fieldbase = `course${courseIndex}_participant`
                    const hiddenFieldname = `Courses[${courseIndex}].Code`
                    const participantCount = course.participantCount
                    let participantFieldsCreated = 0
                    let fields = []
            

                    // each participant
                    while(participantCount > participantFieldsCreated){
                        fields.push(fieldlist.map(field => {
                            const internalFieldname = `${fieldbase}${participantFieldsCreated}_${field}`
                            return this.participantForm[internalFieldname]
                        }))
                        participantFieldsCreated++
                    }

                    return {
                        courseTitle: course.courseTitle,
                        date: course.date,
                        location: course.location,
                        duration: course.duration,
                        participants: fields,
                        participantCount: fields.length,
                        code: course.code,
                        hiddenFieldname
                    }
                })
            } else {
                return []
            }
            
        },
        attemptedSubmit(){
            return this.$store.state.cart.attemptedSubmit
        },
        conditions(){
            return this.$store.state.cart.acceptedConditions
        },
        newsletter(){
            return this.$store.state.cart.acceptedNewsletter
        },
        label() {
            return Store.state.main.labels
        },
        renderMobile(){
            const width = this.windowWidth === 0 ? document.body.clientWidth : this.windowWidth
            const mobileBreakpoint = 920
            return width <= mobileBreakpoint ? true : false
        },
        renderDesktop(){
            return !this.renderMobile
        }        
    },
    methods: {
        getCountryNames() {
            if (this.$store.state.main.labels && this.$store.state.main.labels.countryNames) {
                return this.$store.state.main.labels.countryNames.map(item => {
                    return item
                })
            }
        },
        displayValidationResult(element){
            
            let classname = ''
            let validates = element.validates
            let hasValidationAttribute = element.required || !!(element.maxlengthvalidate)
            let display = this.attemptedSubmit

            if(display && (validates !== undefined && hasValidationAttribute)){
                classname = validates ? 'nti-checkout-billing__valid' : 'nti-checkout-billing__invalid'
            }
            return classname
        },
        runValidators(){
            this.readyToSubmit = null // force reset before each round of checks
            const checkoutForm = this.form
            const participantForm = this.participantForm

            const validate = (form)=>{
                for(let element in form){
                    const inputfield = form[element]
                    const isvalid = inputfield.validator(inputfield)
                    inputfield.validates = isvalid

                    if(inputfield.required && (this.readyToSubmit === null || this.readyToSubmit)){
                        if(includeInValidation(this,inputfield.validateNow)){
                            this.readyToSubmit = isvalid
                        }
                    }
                }
            }

            validate(checkoutForm)
            validate(participantForm)
            
            this.$store.commit('cart/setFormComplete',this.readyToSubmit)
        },
        buildParticipantForm(clearParticipantFields){

            const oneCourseWithAlternateParticipant = (this.courseParticipantList.length  === 1 && this.alternateParticipant)
            const severalCourses = (this.courseParticipantList.length > 1)
            const oneCourseManyParticipants = !!(
                !severalCourses &&
                this.courseParticipantList.length > 0 &&
                this.courseParticipantList[0].participantCount > 1
            )
            const doNotCopyFromForm = (oneCourseWithAlternateParticipant || oneCourseManyParticipants || severalCourses)

            if(this.showCourseParticipantInput){
                const newParticipantFields = {}
                this.courseParticipantList.forEach((course,courseIndex) => {
    
                    // each course
                    const participantCount = course.participantCount
                    let participantFieldsCreated = 0
                    const fieldlist = this.participantFieldlist
                    const fieldbase = `course${courseIndex}_participant`
                    const serverField = `Courses[${courseIndex}].Participants`
    
                    // each participant
                    while(participantCount > participantFieldsCreated){
                        const currentParticipant = participantFieldsCreated

                        const setDefaultValue = (fieldname,internalFieldname) => {

                            const inheritedValue = this.participantForm[internalFieldname] ? this.participantForm[internalFieldname].value : ''
                            const actions = {
                                Name : () => {
                                    const concatenatedName = this.form.firstname.value ? `${this.form.firstname.value} ${this.form.lastname.value}` : ''
                                    return doNotCopyFromForm ? inheritedValue : concatenatedName
                                },
                                Email : () =>{
                                    const billingEmail = this.form.email.value
                                    return doNotCopyFromForm ? inheritedValue : billingEmail
                                },
                                Phone : () => {
                                    const billingPhone = this.form.telephone.value
                                    return doNotCopyFromForm ? inheritedValue : billingPhone
                                }
                            }

                            const actionPossible = !!(actions && actions[fieldname])
                            
                            return clearParticipantFields 
                                ? '' 
                                : actionPossible 
                                    ? actions[fieldname]() 
                                    : doNotCopyFromForm 
                                        ? ''
                                        : inheritedValue
                        }
    
                        // each field
                        fieldlist.forEach(fieldname => {
                            const internalFieldname = `${fieldbase}${currentParticipant}_${fieldname}`
                            const serverFieldName = `${serverField}[${currentParticipant}].${fieldname}`
                            const displayName = `participant${fieldname}`
                            const required = fieldname !== 'Position' ? true : false
                            const validateNow = required
                            newParticipantFields[internalFieldname] = generateInput('text',serverFieldName,displayName,required,validateNow,(fieldname === 'Email' ? validateEmail : notempty),null,setDefaultValue(fieldname,internalFieldname))
                        })

                        participantFieldsCreated++
                    }
                    
                })

                const newForm = Object.assign({},this.participantForm,newParticipantFields)
                this.participantForm = newForm
            }
        },
        verifyLabel(displayName) {
            if (this.$store.state.main.labels) {
                return verifyLabel(displayName, this.$store.state.main.labels)
            } else {
                return ""
            }
        },
        combineValidators(...validators) {
            return function (value) {
                return validators.every(validator => validator(value));
            };
        }
    },
    watch: {
        useAlternateDeliveryAddress(){
            this.runValidators()
        },
        alternateParticipant(){
            this.buildParticipantForm(this.alternateParticipant)
            this.runValidators()
        },
        attemptedSubmit(){
            this.runValidators()
        },
        form : {
            handler(newVal){
                this.runValidators()
                this.buildParticipantForm()
            },
            deep: true
        },
        participantForm : {
            handler(newVal){
                this.runValidators()
            },
            deep: true
        },
        showCourseParticipantInput(){
           this.buildParticipantForm()
        }
    },
    components: {
        FormBase,
        CheckoutCourseParticipants
    },
    mounted(){
        window.addEventListener('resize', ()=>{
            this.windowWidth = document.body.clientWidth
        })
    }
}